<template>
  <v-container fluid class="mt-5">
    <v-row justify="start">
      <v-col cols="12" lg="4" md="6" sm="12">
        <v-card>
          <v-card-title>
            Date di validità
          </v-card-title>
          <v-card-subtitle>
            L'offerta è applicata solo nel periodo impostato
          </v-card-subtitle>
          <v-card-text>
            <v-row align="center" justify="start" dense>
              <v-col>
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedStartFormatted"
                      label="Dalla data"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      hide-details
                      @click:clear="dati.dataDa = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dati.dataDa" no-title scrollable @input="menuStart = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedEndFormatted"
                      label="Alla data"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      hide-details
                      @click:clear="dati.dataA = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dati.dataA" no-title scrollable @input="menuEnd = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="12">
        <v-card>
          <v-card-title>
            Orari di validità
          </v-card-title>
          <v-card-subtitle>
            L'offerta è applicata solo nei periodi orari specificati. Se non viene specificato alcun periodo, è sempre applicata nelle date di validità.
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Dalle</th>
                    <th class="text-center">Alle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(st, index) in dati.orari" :key="index">
                    <td width="40%"><v-text-field type="time" v-model="st.oraDa" :max="st.oraA" required /></td>
                    <td width="40%"><v-text-field type="time" v-model="st.oraA" :min="st.oraDa" required /></td>
                    <td><v-btn icon @click="deleteItem(st)"><v-icon>mdi-delete-outline</v-icon></v-btn></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row align="center" justify="end" class="mt-5">
              <v-btn class="mx-3 mb-5" fab small color="primary" @click="addItem()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-btn v-if="!readOnly" class="mt-5" @click="salvaModifiche">Salva modifiche</v-btn>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'

  export default {
    props: {
      dati: Object,
      readOnly: { type: Boolean, default: false }
    },    
    data: (vm) => ({
      startFormatted: vm.formatDate(moment().add(-15, 'days').utcOffset(0, true).format('YYYY-MM-DD')),
      endFormatted: vm.formatDate(moment().utcOffset(0, true).format('YYYY-MM-DD')),
/*       start: moment().add(-15, 'days').utcOffset(0, true).format('YYYY-MM-DD'),
      end: moment().utcOffset(0, true).format('YYYY-MM-DD'), */
      menuStart: false,
      menuEnd: false,
      modal: false,
      loading: false,
      orari: [],
      editedIndex: -1,
      editedItem: null,
      dialogDelete: false
    }),
    created() {
    },
    async mounted() {
      if (this.dati) {
/*         this.start = this.dati.dataDa && moment(this.dati.dataDa).utcOffset(0, true).format('YYYY-MM-DD')
        this.end = this.dati.dataA && moment(this.dati.dataA).utcOffset(0, true).format('YYYY-MM-DD') */
        // this.orari = this.dati.orari || []
      }
    },
    computed: {
      computedStartFormatted () {
        return this.formatDate(this.dati.dataDa)
      },
      computedEndFormatted () {
        return this.formatDate(this.dati.dataA)
      }
    },
    watch: {
      'dati.dataDa' (val) {
        this.startFormatted = this.formatDate(this.dati.dataDa)
      },
      'dati.dataA'(val) {
        this.endFormatted = this.formatDate(this.dati.dataA)
      },
      dati() {
/*         this.start = this.dati.dataDa && moment(this.dati.dataDa).utcOffset(0, true).format('YYYY-MM-DD'),
        this.end = this.dati.dataA && moment(this.dati.dataA).utcOffset(0, true).format('YYYY-MM-DD'), */
       //  this.orari = this.dati.orari || []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      addItem() {
        this.dati.orari = this.dati.orari || []
        this.dati.orari.push({ oraDa: '', oraA: '' })
      },
      deleteItem (item) {
        this.editedIndex = this.dati.orari.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.dati.orari.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = null
          this.editedIndex = -1
        })
      },
      salvaModifiche() {
        this.$emit('salva', this.dati)
      }      
    }
  }
</script>
